module.exports = __webpack_public_path__ + "static/media/blood1.edb37bda.svg";